import isString from 'lodash/isString';

export default (sectionHash) => {
  if (!sectionHash || !isString(sectionHash)) return '';

  return sectionHash.startsWith('#s-')
    ? sectionHash
    : `#s-${sectionHash.substring(1)}`;
};
